// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as FilterPartner from "./FilterPartner.bs.js";

function offset_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "value"), null));
  if (value.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              value: value._0
            }
          };
  }
  var e = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var offset = offset_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
  if (offset.TAG === /* Ok */0) {
    var total_count = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "total_count"), null));
    if (total_count.TAG === /* Ok */0) {
      var drivers = Decco.listFromJson(FilterPartner.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "drivers"), null));
      if (drivers.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  offset: offset._0,
                  total_count: total_count._0,
                  drivers: drivers._0
                }
              };
      }
      var e = drivers._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".drivers" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = total_count._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".total_count" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = offset._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".offset" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  offset_decode ,
  t_decode ,
  
}
/* FilterPartner Not a pure module */
